import { TApplicationState } from 'shared/types/redux';

export const selectBusinessAppointmentsRaw = (state: TApplicationState) => state.businessAppointmentOptions;
